function initTdsLibrary(section) {
  var _a;
  if (!section || section.dataset.tdsReady === "true") return;
  section.dataset.tdsReady = "true";
  const search = section.querySelector("[data-tds-search]");
  const filter = section.querySelector("[data-tds-filter]");
  const tabs = Array.from(section.querySelectorAll("[data-tds-tab]"));
  const cards = Array.from(section.querySelectorAll("[data-tds-card]"));
  const count = section.querySelector("[data-tds-count]");
  const empty = section.querySelector("[data-tds-empty]");
  const viewer = section.querySelector("[data-tds-viewer]");
  const frame = section.querySelector("[data-tds-frame]");
  const placeholder = section.querySelector("[data-tds-placeholder]");
  const viewerTitle = section.querySelector("[data-tds-viewer-title]");
  const viewerOpen = section.querySelector("[data-tds-viewer-open]");
  const pagination = section.querySelector("[data-tds-pagination]");
  const prevPageButton = section.querySelector("[data-tds-page-prev]");
  const nextPageButton = section.querySelector("[data-tds-page-next]");
  const pageStatus = section.querySelector("[data-tds-page-status]");
  const cardsPerPage = 10;
  const gateModal = section.querySelector("[data-tds-gate-modal]");
  const gateFormWrap = section.querySelector("[data-tds-gate-form]");
  const gateContinue = section.querySelector("[data-tds-gate-continue]");
  const gateMode = section.dataset.tdsGate || "none";
  const gateArmed = gateMode !== "none" && !!gateModal && !!gateFormWrap;
  const GATE_KEY = "starshield:tds-lead-unlocked-v2";
  let pending = null;
  let gateWatching = false;
  let gateFormSeen = false;
  const gateObservers = [];
  const gateBoundRoots = [];
  const gateRootSawForm = /* @__PURE__ */ new WeakMap();
  const scope = section.dataset.tdsScope || "all";
  let activeType = ((_a = tabs.find((tab) => tab.classList.contains("is-active"))) == null ? void 0 : _a.dataset.tdsTab) || (scope === "all" ? "catalogue" : scope);
  let currentPage = 1;
  function setCount(visibleCount) {
    if (!count) return;
    const label = activeType === "catalogue" ? "catalogue" : "TDS";
    count.textContent = visibleCount === 1 ? "1 " + label + " document" : visibleCount + " " + label + " documents";
  }
  function gateUnlocked() {
    try {
      return window.localStorage.getItem(GATE_KEY) === "1";
    } catch (error) {
      return false;
    }
  }
  function rememberVisitor() {
    try {
      window.localStorage.setItem(GATE_KEY, "1");
    } catch (error) {
    }
  }
  function gateBlocks(card) {
    if (!gateArmed || gateUnlocked()) return false;
    const type = (card == null ? void 0 : card.dataset.docType) || "tds";
    return gateMode === "all" || type === "tds";
  }
  function gateStepOf(root) {
    for (const node of gateRootsUnder(root)) {
      const host = node.getElementById ? node.getElementById("app-embed") : node.querySelector("#app-embed");
      if (host) return host.getAttribute("data-current-step") || "";
    }
    return "";
  }
  const SUBMIT_LABEL = "Access TDS";
  function relabelSubmit(root) {
    root.querySelectorAll("[class*=_formSubmitButton_], .btn-form-submit").forEach((btn) => {
      const target = Array.from(btn.querySelectorAll("*")).find((n) => !n.children.length && n.textContent.trim()) || btn;
      if (target.textContent.trim() !== SUBMIT_LABEL) target.textContent = SUBMIT_LABEL;
    });
  }
  function inspectGateRoot(root) {
    const step = gateStepOf(root);
    const hasForm = gateRootsUnder(root).some((node) => node.querySelector("form"));
    gateRootsUnder(root).forEach((node) => {
      compactGateForm(node);
      hideFormChrome(node);
      relabelSubmit(node);
      syncGateFloats(node);
      if (node !== root) bindGateRoot(node);
    });
    if (step === "form" || hasForm) {
      gateRootSawForm.set(root, true);
      gateFormSeen = true;
    }
    if (!gateRootSawForm.get(root)) return;
    if (/success|submit|thank/i.test(step) || step && step !== "form" || !hasForm) unlockGate();
  }
  const GATE_FORM_CSS = [
    ":host{display:block;width:100%;padding-inline:2px;box-sizing:border-box}",
    "*{scrollbar-width:none!important;-ms-overflow-style:none!important;box-sizing:border-box!important}",
    "*::-webkit-scrollbar{display:none!important;width:0!important;height:0!important}",
    "form,fieldset{width:100%!important;max-width:100%!important;min-width:0!important;margin:0!important;padding:0!important;border:0!important;box-sizing:border-box!important}",
    "form{display:flex!important;flex-direction:column!important;gap:14px!important}",
    // The app uses a floating label that sits *inside* the field, so its
    // geometry is left alone — forcing a 44px box with no top padding made the
    // label land on top of what the visitor typed. Only colour, border, radius
    // and type are restyled; height and padding stay the app's.
    "input,select,textarea{width:100%!important;max-width:100%!important;min-width:0!important;min-height:56px!important;background:#f6f7f9!important;border:1px solid #d6dbe6!important;border-radius:10px!important;box-shadow:none!important;outline:none!important;font-family:var(--ss-font-primary,inherit)!important;font-size:14px!important;color:#1a1a1a!important;transition:border-color .2s ease,background .2s ease,box-shadow .2s ease!important}",
    "input,textarea{padding:22px 14px 8px!important}",
    "select{padding:0 14px!important}",
    "textarea{min-height:88px!important}",
    // ponytail: the label is positioned outright — resting centred, raised by
    // the .tds-gate-float class the script toggles — rather than riding the
    // app's own float, whose offsets are not readable from here. Cost: a label
    // the app does NOT already position absolutely would be yanked out of
    // flow. Revisit if the app exposes a stable class for its field wrapper.
    "label{position:absolute!important;top:50%!important;left:14px!important;right:14px!important;margin:0!important;transform:translateY(-50%)!important;font-family:var(--ss-font-primary,inherit)!important;font-size:14px!important;font-weight:400!important;letter-spacing:0!important;line-height:1.2!important;color:#8b94a7!important;pointer-events:none!important;overflow:hidden!important;text-overflow:ellipsis!important;white-space:nowrap!important;transition:top .15s ease,transform .15s ease,font-size .15s ease,color .15s ease!important}",
    ".tds-gate-float label{top:8px!important;transform:none!important;font-size:11px!important;font-weight:600!important;letter-spacing:.2px!important;line-height:1!important;color:#6b7891!important}",
    "input::placeholder,textarea::placeholder{color:#a0a8b8!important;opacity:1!important}",
    "input:focus,select:focus,textarea:focus{border-color:var(--ss-brand-primary,#c40000)!important;background:#fff!important;box-shadow:inset 0 0 0 1px var(--ss-brand-primary,#c40000)!important}",
    "input[aria-invalid=true],select[aria-invalid=true],textarea[aria-invalid=true],input:user-invalid,select:user-invalid,textarea:user-invalid{border-color:var(--ss-danger,#dc2626)!important;background:#fff!important;box-shadow:inset 0 0 0 1px var(--ss-danger,#dc2626)!important}",
    ".tds-gate-error{display:block!important;margin:6px 0 0!important;font-family:var(--ss-font-primary,inherit)!important;font-size:12px!important;font-weight:500!important;color:var(--ss-danger,#dc2626)!important;line-height:1.35!important}",
    ".btn-form-submit,[class*=_formSubmitButton_]{width:100%!important;height:50px!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:10px!important;border:0!important;border-radius:12px!important;padding:0 20px!important;background:var(--ss-brand-primary,#c40000)!important;color:#fff!important;font-family:var(--ss-font-primary,inherit)!important;font-size:14px!important;font-weight:600!important;letter-spacing:.3px!important;line-height:1!important;cursor:pointer!important;transition:background .2s ease!important}",
    ".btn-form-submit:hover,[class*=_formSubmitButton_]:hover{background:#a80000!important}"
  ].join("");
  function gateRootsUnder(start) {
    const roots = [start];
    for (let i = 0; i < roots.length; i += 1) {
      roots[i].querySelectorAll("*").forEach((node) => {
        if (node.shadowRoot && roots.indexOf(node.shadowRoot) === -1) roots.push(node.shadowRoot);
      });
    }
    return roots;
  }
  function compactGateForm(root) {
    if (!root.host || root.querySelector("style[data-tds-compact]")) return;
    const style = document.createElement("style");
    style.setAttribute("data-tds-compact", "");
    style.textContent = GATE_FORM_CSS;
    root.appendChild(style);
  }
  const HIDDEN_FORM_TEXT = /tell us where to send this document|by signing up|marketing emails|whatsapp messages/i;
  function hideFormChrome(root) {
    const hits = Array.from(root.querySelectorAll("h1, h2, h3, h4, p, div, span, small, label")).filter(
      (node) => HIDDEN_FORM_TEXT.test(node.textContent || "")
    );
    hits.filter((node) => !hits.some((other) => other !== node && node.contains(other))).filter((node) => !node.querySelector("input, select, textarea, button")).forEach((node) => {
      node.style.setProperty("display", "none", "important");
    });
  }
  function gateFieldsOf(form) {
    return Array.from(form.querySelectorAll("input, select, textarea")).filter(
      (el) => !/^(hidden|submit|button|reset|checkbox|radio|image|file)$/i.test(el.type || "")
    );
  }
  function gateRequiredOf(form) {
    const fields = gateFieldsOf(form);
    const required = fields.filter((el) => el.required || el.getAttribute("aria-required") === "true");
    return required.length ? required : fields;
  }
  function gateSubmitLooksReal(root) {
    return gateRootsUnder(root).some(
      (node) => Array.from(node.querySelectorAll("form")).some((form) => {
        if (!gateFieldsOf(form).length) return false;
        return gateRequiredOf(form).every((el) => (el.value || "").trim()) && form.checkValidity();
      })
    );
  }
  const GATE_ERROR_CLASS = "tds-gate-error";
  function gateFieldError(el, required) {
    if (required && !(el.value || "").trim()) return "This field is required.";
    if (!el.checkValidity()) return el.validationMessage || "Please check this field.";
    return "";
  }
  function gateNoteOf(el) {
    const note = el.nextElementSibling;
    return note && note.classList.contains(GATE_ERROR_CLASS) ? note : null;
  }
  function clearGateField(el) {
    var _a2;
    el.removeAttribute("aria-invalid");
    (_a2 = gateNoteOf(el)) == null ? void 0 : _a2.remove();
  }
  function markGateFields(root) {
    let firstBad = null;
    gateRootsUnder(root).forEach(
      (node) => Array.from(node.querySelectorAll("form")).forEach((form) => {
        const required = gateRequiredOf(form);
        gateFieldsOf(form).forEach((el) => {
          const message = gateFieldError(el, required.indexOf(el) !== -1);
          if (!message) return clearGateField(el);
          el.setAttribute("aria-invalid", "true");
          let note = gateNoteOf(el);
          if (!note) {
            note = el.ownerDocument.createElement("span");
            note.className = GATE_ERROR_CLASS;
            el.insertAdjacentElement("afterend", note);
          }
          if (note.textContent !== message) note.textContent = message;
          if (!firstBad) firstBad = el;
        });
      })
    );
    firstBad == null ? void 0 : firstBad.focus();
  }
  const GATE_FLOAT_CLASS = "tds-gate-float";
  function gateFieldWrap(el) {
    let node = el.parentElement;
    while (node && !(node.querySelector("label") && node.querySelectorAll("input, select, textarea").length === 1)) {
      node = node.parentElement;
    }
    return node;
  }
  function syncGateFloat(el, focused) {
    const wrap = gateFieldWrap(el);
    if (!wrap) return;
    const float = focused || !!(el.value || "").trim() || el.tagName === "SELECT";
    wrap.classList.toggle(GATE_FLOAT_CLASS, float);
  }
  function syncGateFloats(root) {
    gateRootsUnder(root).forEach(
      (node) => node.querySelectorAll("input, select, textarea").forEach((el) => {
        if (/^(hidden|submit|button|reset|checkbox|radio|image|file)$/i.test(el.type || "")) return;
        syncGateFloat(el, node.activeElement === el);
      })
    );
  }
  function bindGateRoot(root) {
    if (!root || gateBoundRoots.indexOf(root) !== -1) return;
    gateBoundRoots.push(root);
    root.addEventListener(
      "submit",
      () => {
        markGateFields(root);
        if (!gateSubmitLooksReal(root)) return;
        window.setTimeout(() => {
          if (gateContinue && !gateUnlocked()) gateContinue.hidden = false;
        }, 2500);
      },
      true
    );
    root.addEventListener(
      "input",
      (event) => {
        var _a2;
        const el = event.target;
        if (!((_a2 = el == null ? void 0 : el.matches) == null ? void 0 : _a2.call(el, "input, select, textarea"))) return;
        syncGateFloat(el, true);
        if (el.hasAttribute("aria-invalid") && !gateFieldError(el, true)) clearGateField(el);
      },
      true
    );
    ["focusin", "focusout"].forEach(
      (type) => root.addEventListener(
        type,
        (event) => {
          var _a2;
          const el = event.target;
          if ((_a2 = el == null ? void 0 : el.matches) == null ? void 0 : _a2.call(el, "input, select, textarea")) syncGateFloat(el, type === "focusin");
        },
        true
      )
    );
    const observer = new MutationObserver(() => inspectGateRoot(root));
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-current-step", "class", "hidden", "style"]
    });
    gateObservers.push(observer);
    inspectGateRoot(root);
  }
  function watchGateForm() {
    if (!gateFormWrap || gateWatching) return;
    gateWatching = true;
    const attach = () => {
      const embed = gateFormWrap.querySelector("shopify-forms-embed, shopify-forms-embed-dev");
      if (embed == null ? void 0 : embed.shadowRoot) bindGateRoot(embed.shadowRoot);
    };
    attach();
    const hostObserver = new MutationObserver(attach);
    hostObserver.observe(gateFormWrap, { childList: true, subtree: true });
    gateObservers.push(hostObserver);
    bindGateRoot(gateFormWrap);
  }
  function openGate(card, action) {
    if (!gateModal) return;
    pending = { card, action };
    gateModal.hidden = false;
    if (gateContinue) gateContinue.hidden = true;
    document.documentElement.classList.add("tds-gate-open");
    watchGateForm();
    const focusable = gateModal.querySelector("input, select, textarea, button");
    focusable == null ? void 0 : focusable.focus({ preventScroll: true });
    window.setTimeout(() => {
      if (!gateFormSeen && !gateUnlocked() && gateContinue) gateContinue.hidden = false;
    }, 6e3);
  }
  function closeGate() {
    if (!gateModal) return;
    gateModal.hidden = true;
    document.documentElement.classList.remove("tds-gate-open");
  }
  function unlockGate() {
    if (gateUnlocked() && !pending) return;
    rememberVisitor();
    gateObservers.forEach((observer) => observer.disconnect());
    gateObservers.length = 0;
    const target = pending;
    pending = null;
    closeGate();
    if (!(target == null ? void 0 : target.card)) return;
    setViewer(target.card);
    if (target.action === "open" && target.card.dataset.pdf) {
      window.open(target.card.dataset.pdf, "_blank", "noopener");
    }
  }
  const placeholderText = placeholder == null ? void 0 : placeholder.querySelector("p");
  const placeholderCopy = (placeholderText == null ? void 0 : placeholderText.textContent) || "";
  function lockViewer(card) {
    if (!viewer || !frame) return;
    cards.forEach((item) => item.classList.toggle("is-active", item === card));
    if (viewerTitle) viewerTitle.textContent = (card == null ? void 0 : card.dataset.title) || "Select a document";
    if (viewerOpen) {
      viewerOpen.href = "#";
      viewerOpen.hidden = true;
    }
    frame.removeAttribute("src");
    viewer.classList.remove("has-pdf");
    viewer.classList.add("is-locked");
    if (placeholderText) placeholderText.textContent = "Enter your details to preview this document.";
    if (placeholder) placeholder.hidden = false;
  }
  function resetViewer() {
    cards.forEach((item) => item.classList.remove("is-active"));
    if (viewerTitle) viewerTitle.textContent = activeType === "catalogue" ? "Select a catalogue" : "Select a TDS";
    if (viewerOpen) {
      viewerOpen.href = "#";
      viewerOpen.hidden = true;
    }
    if (frame) frame.removeAttribute("src");
    if (viewer) viewer.classList.remove("has-pdf");
    if (placeholder) placeholder.hidden = false;
  }
  function setViewer(card) {
    if (!viewer || !frame || !card) return;
    if (gateBlocks(card)) {
      lockViewer(card);
      return;
    }
    const pdfUrl = card.dataset.pdf || "";
    const title = card.dataset.title || "Technical Data Sheet";
    viewer.classList.remove("is-locked");
    if (placeholderText) placeholderText.textContent = placeholderCopy;
    cards.forEach((item) => item.classList.toggle("is-active", item === card));
    if (viewerTitle) viewerTitle.textContent = title;
    if (viewerOpen) {
      viewerOpen.href = pdfUrl || "#";
      viewerOpen.hidden = !pdfUrl;
    }
    if (pdfUrl) {
      frame.src = pdfUrl;
      viewer.classList.add("has-pdf");
      if (placeholder) placeholder.hidden = true;
    } else {
      frame.removeAttribute("src");
      viewer.classList.remove("has-pdf");
      if (placeholder) placeholder.hidden = false;
    }
  }
  function updatePagination(totalCards) {
    const totalPages = Math.ceil(totalCards / cardsPerPage);
    if (!pagination || totalPages <= 1) {
      if (pagination) pagination.hidden = true;
      return totalPages;
    }
    pagination.hidden = false;
    if (pageStatus) pageStatus.textContent = "Page " + currentPage + " of " + totalPages;
    if (prevPageButton) prevPageButton.disabled = currentPage <= 1;
    if (nextPageButton) nextPageButton.disabled = currentPage >= totalPages;
    return totalPages;
  }
  function applyFilters() {
    const query = ((search == null ? void 0 : search.value) || "").trim().toLowerCase();
    const category = ((filter == null ? void 0 : filter.value) || "").trim().toLowerCase();
    const matchingCards = [];
    let firstVisible = null;
    cards.forEach((card) => {
      const matchesQuery = !query || (card.dataset.search || "").includes(query);
      const matchesCategory = !category || card.dataset.category === category;
      const matchesType = (card.dataset.docType || "tds") === activeType;
      const visible = matchesType && matchesQuery && matchesCategory;
      if (visible) {
        matchingCards.push(card);
        firstVisible = firstVisible || card;
      }
    });
    const visibleCount = matchingCards.length;
    const totalPages = Math.max(1, Math.ceil(visibleCount / cardsPerPage));
    currentPage = Math.min(currentPage, totalPages);
    const firstPageIndex = (currentPage - 1) * cardsPerPage;
    const firstVisibleOnPage = matchingCards[firstPageIndex] || null;
    cards.forEach((card) => {
      const pageIndex = matchingCards.indexOf(card);
      const visibleOnPage = pageIndex >= firstPageIndex && pageIndex < currentPage * cardsPerPage;
      card.hidden = pageIndex === -1 || !visibleOnPage;
    });
    setCount(visibleCount);
    updatePagination(visibleCount);
    if (empty) empty.hidden = visibleCount !== 0;
    const activeCard = cards.find((card) => card.classList.contains("is-active") && !card.hidden);
    if (!activeCard && firstVisibleOnPage) setViewer(firstVisibleOnPage);
    if (!firstVisible) resetViewer();
  }
  cards.forEach((card) => {
    const viewButton = card.querySelector("[data-tds-view]");
    viewButton == null ? void 0 : viewButton.addEventListener("click", () => {
      if (gateBlocks(card)) {
        openGate(card, "view");
        return;
      }
      setViewer(card);
    });
    const openLink = card.querySelector('a[href][target="_blank"]');
    openLink == null ? void 0 : openLink.addEventListener("click", (event) => {
      if (!gateBlocks(card)) return;
      event.preventDefault();
      openGate(card, "open");
    });
  });
  viewerOpen == null ? void 0 : viewerOpen.addEventListener("click", (event) => {
    const activeCard = cards.find((card) => card.classList.contains("is-active"));
    if (!activeCard || !gateBlocks(activeCard)) return;
    event.preventDefault();
    openGate(activeCard, "open");
  });
  section.querySelectorAll("[data-tds-gate-close]").forEach((node) => {
    node.addEventListener("click", closeGate);
  });
  gateContinue == null ? void 0 : gateContinue.addEventListener("click", unlockGate);
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && gateModal && !gateModal.hidden) closeGate();
  });
  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      activeType = tab.dataset.tdsTab || "catalogue";
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle("is-active", active);
        item.setAttribute("aria-selected", active ? "true" : "false");
      });
      currentPage = 1;
      applyFilters();
    });
  });
  search == null ? void 0 : search.addEventListener("input", () => {
    currentPage = 1;
    applyFilters();
  });
  filter == null ? void 0 : filter.addEventListener("change", () => {
    currentPage = 1;
    applyFilters();
  });
  prevPageButton == null ? void 0 : prevPageButton.addEventListener("click", () => {
    if (currentPage <= 1) return;
    currentPage -= 1;
    applyFilters();
  });
  nextPageButton == null ? void 0 : nextPageButton.addEventListener("click", () => {
    currentPage += 1;
    applyFilters();
  });
  const firstWithPdf = cards.find((card) => card.dataset.pdf && (card.dataset.docType || "tds") === activeType);
  if (firstWithPdf) setViewer(firstWithPdf);
  applyFilters();
}
function initAllTdsLibraries() {
  document.querySelectorAll(".tds-library").forEach(initTdsLibrary);
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAllTdsLibraries);
} else {
  initAllTdsLibraries();
}
document.addEventListener("shopify:section:load", (event) => {
  initTdsLibrary(event.target.querySelector(".tds-library"));
});
